// extracted by mini-css-extract-plugin
export default {"container":"Ap-z","ratingLayout":"Bp-z","ratingLabel":"Cp-z","nonInteractiveRatingLabel":"Dp-z"};